import React from 'react';
import { Link, useLocation } from 'react-router-dom'

function Nav() {

    const location = useLocation()
    const path = location.pathname

    return <div>
        <ul className="flex flex-wrap mb-10  m-auto rounded-2xl w-2/3 text-white justify-center">
            <Link to='/'><li className={`text-base sm:text-lg lg:text-xl text-center  px-5 sm:px-10  py-1 sm:py-3 m-3  sm:m-6 inline-block rounded-2xl bg-slate-700 ease-out duration-300 ${path === '/All' ? 'bg-[#772ce8]' : ''}`}>All</li></Link>
            <Link to='Chat'>
                <li className={`text-base sm:text-lg lg:text-xl text-center  px-5 sm:px-10  py-1 sm:py-3 m-3  sm:m-6 inline-block rounded-2xl bg-slate-700 ${path === '/Chat' ? 'bg-[#772ce8]' : ''}`}>JustChatting</li>
            </Link>
            <Link to='LOL'>
                <li className={`text-base sm:text-lg lg:text-xl text-center  px-5 sm:px-10  py-1 sm:py-3 m-3  sm:m-6 inline-block rounded-2xl bg-slate-700 ${path === '/LOL' ? 'bg-[#772ce8]' : ''}`}>League of Legends</li>
            </Link>
            <Link to='Apex'>
                <li className={`text-base sm:text-lg lg:text-xl text-center  px-5 sm:px-10  py-1 sm:py-3 m-3  sm:m-6 inline-block rounded-2xl bg-slate-700 ${path === '/Apex' ? 'bg-[#772ce8]' : ''}`}>Apex Legends</li>
            </Link>
        </ul>
    </div>;
}

export default Nav;
